import React,{useEffect} from 'react'
import img1 from '../../img/selab/selab5.jpeg'
import img2 from "../../img/selab/selab6.jpeg"

const AboutConent1 = () => {
    useEffect(() => {
        function getRandomInt(max) {
            return Math.floor(Math.random() * max);
          }
          // const counter1=getRandomInt(10);
          // console.log("counter1",counter1)
          // const connt1=document.getElementById("count1").innerHTML=counter1
          // console.log("connt1",connt1)


          // const counter2=getRandomInt(10);
          // console.log("counter2",counter2)
          // const connt2=document.getElementById("count2").innerHTML=counter1
          // console.log("connt2",connt2)


          // const counter3=getRandomInt(10);
          // console.log("counter3",counter3)
          // const connt3=document.getElementById("count3").innerHTML=counter1
          // console.log("connt3",connt3)


          // const counter4=getRandomInt(10);
          // console.log("counter4",counter4)
          // const connt4=document.getElementById("count4").innerHTML=counter1
          // console.log("connt4",connt4)
     
    }, [])
    
  return (
    <div>
        {/* About Start */}
  <div className="about">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-lg-6">
          {/* <div className="about-img" data-parallax="scroll" data-image-src={img1} /> */}
          <img className="about-img" data-parallax="scroll"  src={img1}/>
        </div>
        <div className="col-lg-6">
          <div className="section-header">
            <p>Learn About Us</p>
            <h2>Worldwide non-profit charity organization</h2>
          </div>
          <div className="about-tab">
            <ul className="nav nav-pills nav-justified">
              <li className="nav-item">
                <a className="nav-link active" data-toggle="pill" href="#tab-content-1">About</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="pill" href="#tab-content-2">Mission</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" data-toggle="pill" href="#tab-content-3">Vision</a>
              </li>
            </ul>
            <div className="tab-content">
              <div id="tab-content-1" className="container tab-pane active">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. In vitae pellentesque turpis. Donec in hendrerit dui, vel blandit massa. Ut vestibulum suscipit cursus. Cras quis porta nulla, ut placerat risus. Aliquam nec magna eget velit luctus dictum. Phasellus et felis sed purus tristique dignissim. Morbi sit amet leo at purus accumsan pellentesque. Vivamus fermentum nisi vel dapibus blandit. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </div>
              <div id="tab-content-2" className="container tab-pane fade">
                Sed tincidunt, magna ut vehicula volutpat, turpis diam condimentum justo, posuere congue turpis massa in mi. Proin ornare at massa at fermentum. Nunc aliquet sed nisi iaculis ornare. Nam semper tortor eget est egestas, eu sagittis nunc sodales. Interdum et malesuada fames ac ante ipsum primis in faucibus. Praesent bibendum sapien sed purus molestie malesuada. Lorem ipsum dolor sit amet, consectetur adipiscing elit.
              </div>
              <div id="tab-content-3" className="container tab-pane fade">
                Aliquam dolor odio, mollis sed feugiat sit amet, feugiat ut sapien. Nunc eu dignissim lorem. Suspendisse at hendrerit enim. Interdum et malesuada fames ac ante ipsum primis in faucibus. Sed condimentum semper turpis vel facilisis. Nunc vel faucibus orci. Mauris ut mauris rhoncus, efficitur nisi at, venenatis quam. Praesent egestas pretium enim sit amet finibus. Curabitur at erat molestie, tincidunt lorem eget, consequat ligula.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* About End */}
  {/* Facts Start */}
<div className="facts cover" data-parallax="scroll" data-image-src="img/facts.jpg"  data-jarallax="{&quot;speed&quot;: 0.6}" style={{ backgroundImage: `url(${img2})` }}>
  <div className="container">
    <div className="row">
      <div className="col-lg-3 col-md-6">
        <div className="facts-item">
          <i className="flaticon-home" />
          <div className="facts-text">
            <h3 className="facts-plus" data-toggle="counter-up" >5</h3>
            <p>Countries</p>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="facts-item">
          <i className="flaticon-charity" />
          <div className="facts-text">
            <h3 className="facts-plus"  data-toggle="counter-up">50</h3>
            <p>Volunteers</p>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="facts-item">
          <i className="flaticon-kindness" />
          <div className="facts-text">
            <h3 className="facts-dollar" data-toggle="counter-up" >100000</h3>
            <p>Our Goal</p>
          </div>
        </div>
      </div>
      <div className="col-lg-3 col-md-6">
        <div className="facts-item">
          <i className="flaticon-donation" />
          <div className="facts-text">
            <h3 className="facts-dollar" data-toggle="counter-up" >10000</h3>
            <p>Raised</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
{/* Facts End */}
    </div>
  )
}

export default AboutConent1